import React, { useState } from "react";
import CommonChip from "../../card/chip/CommonChip";
import { Tooltip as ReactTooltip } from "react-tooltip";

function JobDesRightInfo({ data }) {
  const [showMoreLocation, setShowMoreLocation] = useState(false);
  const [showMoreYear, setShowMoreYear] = useState(false);
  const [showMoreDegree, setShowMoreDegree] = useState(false);
  const [showMoreSkill, setShowMoreSkill] = useState(false);

  // const getSpecifications =(data) => {
   
  //   const nums = data?.spec.map(val=>val?.name);
  //   let ans = "";
  //   const result = nums.map(val => ans = ans + val +", ");
  //   console.log(ans,result,"getSpecc")
  //   return ans;
  // }

  const text = data?.job_description.replace(/<[^>]+>/g, "");

  return (
    <div>
      <div>
        <h2 className="text-[16px] mb-2">About this job</h2>
        <p className="text-sm text-[#6C757D]">{text}</p>
      </div>

      <div className="mt-3">
        <h2 className="text-[16px] mb-2">Location(s)</h2>
        {!data?.work_from_home ? (
          <div className="flex items-center flex-wrap m-2 ml-0 ">
            {data?.job_location?.length > 0 &&
              !showMoreLocation &&
              data?.job_location?.slice(0, 2)?.map((data1, i) => {
                // const label = `${data1?.city}, ${data1?.state}`
                return (
                  <div className="mr-2 mb-2">
                    <CommonChip label={data1} from="location" />{" "}
                  </div>
                );
              })}
            {data?.job_location?.length > 2 && !showMoreLocation && (
              <p
                className="text-xs text-[#2563EB] cursor-pointer"
                onClick={() => {
                  setShowMoreLocation(!showMoreLocation);
                }}
              >
                {`+${data?.job_location?.length - 2} More...`}
              </p>
            )}

            {data?.job_location?.length > 0 &&
              showMoreLocation &&
              data?.job_location?.map((data1, i) => {
                // const label = `${data1?.city}, ${data1?.state}`
                return (
                  <div className="mr-2 mb-2">
                    <CommonChip label={data1} from="location" />{" "}
                  </div>
                );
              })}
            {data?.job_location?.length > 2 && showMoreLocation && (
              <p
                className="text-xs text-[#2563EB] cursor-pointer"
                onClick={() => {
                  setShowMoreLocation(!showMoreLocation);
                }}
              >
                {`Show Less`}
              </p>
            )}
          </div>
        ) : (
          <>
            <CommonChip label="Work From Home" from="work from home" />{" "}
          </>
        )}
      </div>

      <div className="mt-3">
        <h2 className="text-[16px] mb-2">Education Level</h2>
        {data?.eligibility_criteria?.qualifications?.map((item, index) => {
          const degreeType = item?.education_type_name ?? "";
          const percentage = item?.percentage ?? "";

          return (
            <p className="text-sm text-[#6C757D] mb-2">
              {index + 1 + ". " + degreeType + " with " + percentage + "%"}
            </p>
          );
        })}
      </div>
      <div className="mt-3">
        <h2 className=" text-[16px]  mb-2">Eligible Degrees</h2>
        <div className="flex items-center flex-wrap m-2 ml-0 ">
          {data?.eligibility_criteria?.degrees?.length > 0 &&
            !showMoreDegree &&
            data?.eligibility_criteria?.degrees
              ?.slice(0, 2)
              ?.map((data1, i) => (<>
                <div  className="mr-2 mb-2">
                  {" "}
                  <CommonChip label={data1} from="degree" />{" "} 
                </div>
                {/* <ReactTooltip id={data1?.name} place="top" content={getSpecifications(data1)} /> */}
                </>    
              ))}
          {data?.eligibility_criteria?.degrees?.length > 2 &&
            !showMoreDegree && (
              <p
                className="text-xs text-[#2563EB] cursor-pointer"
                onClick={() => {
                  setShowMoreDegree(!showMoreDegree);
                }}
              >
                {`+${data?.eligibility_criteria?.degrees?.length - 2} More...`}
              </p>
            )}

          {data?.eligibility_criteria?.degrees?.length > 0 &&
            showMoreDegree &&
            data?.eligibility_criteria?.degrees?.map((data1, i) => (
              <div className="mr-2 mb-2">
                <CommonChip label={data1} from="degree" />{" "}
              </div>
            ))}
          {data?.eligibility_criteria?.degrees?.length > 2 &&
            showMoreDegree && (
              <p
                className="text-xs text-[#2563EB] cursor-pointer"
                onClick={() => {
                  setShowMoreDegree(!showMoreDegree);
                }}
              >
                {`Show Less`}
              </p>
            )}
        </div>
      </div>
      {/* <div className="mt-3">
        <h2 className="text-[16px] mb-2">Eligible Graduation Years</h2>
        <div className="flex items-center flex-wrap m-2 ml-0 ">
          {data?.eligibility_criteria?.graduation_years?.length > 0 &&
            !showMoreYear &&
            data?.eligibility_criteria?.graduation_years?.slice(0, 2)?.map((data1, i) => (
              <div className="mr-2 mb-2">
                {" "}
                <CommonChip label={data1} from="years" />{" "}
              </div>
            ))}
          {data?.eligibility_criteria?.graduation_years?.length > 2 &&
            !showMoreYear && (
              <p
                className="text-xs text-[#2563EB] cursor-pointer"
                onClick={() => {
                  setShowMoreYear(!showMoreYear);
                }}
              >
                {`+${
                  data?.eligibility_criteria?.graduation_years?.length - 2
                } More...`}
              </p>
            )}

          {data?.eligibility_criteria?.graduation_years?.length > 0 &&
            showMoreYear &&
            data?.eligibility_criteria?.graduation_years?.map((data1, i) => (
              <div className="mr-2 mb-2">
                <CommonChip label={data1} from="years" />{" "}
              </div>
            ))}
          {data?.eligibility_criteria?.graduation_years?.length > 2 &&
            showMoreYear && (
              <p
                className="text-xs text-[#2563EB] cursor-pointer"
                onClick={() => {
                  setShowMoreYear(!showMoreYear);
                }}
              >
                {`Show Less`}
              </p>
            )}
        </div>
      </div> */}
      <div className="mt-3">
        <h2 className="text-[16px] mb-2">Skills Required</h2>
        <div className="flex items-center flex-wrap m-2 ml-0 ">
          {data?.eligibility_criteria?.skills?.length > 0 &&
            !showMoreSkill &&
            data?.eligibility_criteria?.skills?.slice(0, 2)?.map((data1, i) => (
              <div className="mr-2 mb-2">
                {" "}
                <CommonChip label={data1} from="skills" />{" "}
              </div>
            ))}
          {data?.eligibility_criteria?.skills?.length > 2 && !showMoreSkill && (
            <p
              className="text-xs text-[#2563EB] cursor-pointer"
              onClick={() => {
                setShowMoreSkill(!showMoreSkill);
              }}
            >
              {`+${data?.eligibility_criteria?.skills?.length - 2} More...`}
            </p>
          )}

          {data?.eligibility_criteria?.skills?.length > 0 &&
            showMoreSkill &&
            data?.eligibility_criteria?.skills?.map((data1, i) => (
              <div className="mr-2 mb-2">
                <CommonChip label={data1} from="skills" />{" "}
              </div>
            ))}
          {data?.eligibility_criteria?.skills?.length > 2 && showMoreSkill && (
            <p
              className="text-xs text-[#2563EB] cursor-pointer"
              onClick={() => {
                setShowMoreSkill(!showMoreSkill);
              }}
            >
              {`Show Less`}
            </p>
          )}
        </div>
      </div>

      <div className="mt-3">
        <h2 className="text-[16px] mb-2">Documents Required</h2>
        {data?.documents?.map((item, index) => (
          <p className="text-sm text-[#6C757D] mb-2">
            {index + 1 + ". " + item}
          </p>
        ))}
      </div>
      <div className="mt-3">
        <h2 className="text-[16px] mb-2">Job Rounds</h2>
        {data?.job_rounds?.map((item, index) => (
          <div className="flex items-center ">
            {" "}
            <div className="h-1 w-1  rounded-full bg-[#6C757D] mr-2" />
            <p className="text-sm text-[#6C757D] mb-2 flex items-center">
              {"  Round " + item?.round_no + " "}
              <p className="text-[#2563EB]">&nbsp; ({item?.round_name})</p>
            </p>
          </div>
        ))}
      </div>
      <div className="mt-3">
        <h2 className="text-[16px] mb-2">
          About {data?.company?.company_name}
        </h2>
        <p className="text-sm text-[#6C757D]">
          {data?.company?.company_description?.slice(
            3,
            data?.company?.company_description?.length - 13 ?? " "
          )}
        </p>
      </div>
    </div>
  );
}

export default JobDesRightInfo;
